import React, { Component } from 'react';
import { getDataSources } from '../../../services/dataSourceService';
import CustomLoader from '../../common/Loader';
import { getDT, toFindColumns, saveDT, getSPV, findParameters, saveDTParameters } from '../../../services/formService';
import * as Icon from 'react-feather';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { ResultSource } from '../../../constants/ResultSource';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getProjectForms } from '../../../services/projectService';
import { WidgetTypes } from '../../../constants/QuestionTypes';
import { getProjectLists } from "../../../services/projectService";
import {Form} from 'react-bootstrap';
import { logActivity } from '../../../services/utilService';

class WFilter extends Component {
	DataSources = [];
	Forms = [];
	RowActions = [];
	ResultSources = [];
	StoredProcedures = [];
	Views = [];

	constructor(props) {
		super(props);
		// this.handleSave = this.handleSave.bind(this);
		// this.handleRemove = this.handleRemove.bind(this);
		// this.handleChange = this.handleChange.bind(this);
		// this.handleCheck = this.handleCheck.bind(this);
		// this.clearStatus = this.clearStatus.bind(this);
		// this.handleColumn = this.handleColumn.bind(this);

		this.state = {
			Project_ID: this.props.Project_ID,
			Form_ID: this.props.Form_ID,
			Widget_ID: this.props.Widget.Widget_ID,
			DT_ID: 0,
			DataSource_ID: 0,
			ResultSource_ID: 0,
			ResultSource_Content: '',
			Action_ID: 0,
			Action_Form_ID: 0,
			Display_Name: '',
			Columns: [],
			Parameters: [],
			WithinRow: false,
			selected_column: '',
			can_save: true,
			open_options: '',
			loading: true,
			Data_Tables_List: [],
			Data_Table_Selected: {},
			Data_Table_Selected_Parameters: [],
			Filter_Type_List: [
				{ id: 1, Filter_Type: 'text' },
				{ id: 2, Filter_Type: 'date' },
				{ id: 3, Filter_Type: 'list' },
			],
			Project_Lists:[]
		};
	}

	async componentDidMount() {
		const { data: DS } = await getDataSources();
		const { data: Project_Lists } = await getProjectLists(this.state.Project_ID);

		this.DataSources = DS;

		this.loadDT();
		this.setState({ loading: false,Project_Lists });

		this.getFormDataTables(this.props.Form_Widgets);
	}

	clearStatus = () => {
		this.setState({ DataSource_ID: 0 });
		this.setState({ ResultSource_Content: '' });
		this.setState({ Columns: [] });
		this.setState({ Parameters: [] });
	};

	getOptions = async (DataSource_ID = this.state.DataSource_ID, ResultSource_ID = this.state.ResultSource_ID) => {
		const { data } = await getSPV(ResultSource_ID, this.getConn(DataSource_ID));
		if (ResultSource_ID === ResultSource.SP) {
			this.StoredProcedures = data;
		} else if (ResultSource_ID === ResultSource.View) {
			this.Views = data;
		}
	};

	async loadDT() {
		const { data } = await getDT(this.state.Widget_ID);

		let { data: Forms } = await getProjectForms(this.state.Project_ID);
		this.Forms = Forms.filter((form) => form.Form_ID !== this.props.Form_ID);

		this.RowActions = JSON.parse(data.rowActions);
		this.ResultSources = [{ ResultSource_ID: 0, ResultSource_Type_Name: 'Static Text' }, ...JSON.parse(data.resultSources)];

		const DT = JSON.parse(data.DT)[0];

		if (DT) {
			this.setState({ DT_ID: DT.DT_ID });
			this.setState({ DataSource_ID: DT.DataSource_ID });
			this.setState({ ResultSource_ID: DT.ResultSource_ID });
			this.setState({ ResultSource_Content: DT.ResultSource_Content });
			this.setState({ open_options: DT.ResultSource_Content });
			this.setState({ Action_ID: DT.Action_ID });
			this.setState({ Action_Form_ID: DT.Action_Form_ID });
			this.setState({ Display_Name: DT.Display_Name });
			this.setState({ Columns: JSON.parse(data.Columns) });
			this.setState({ Parameters: JSON.parse(data.Parameters) });
			this.setState({ WithinRow: DT.WithinRow });

			let columns = JSON.parse(data.Columns);
			if (columns.length > 0) {
				let selected_column = columns.find((c) => c.Visible).Column_Name;
				this.setState({ selected_column });
			}

			if (DT.ResultSource_ID > 0) {
				this.getOptions(DT.DataSource_ID, DT.ResultSource_ID);
			}
		}
	}

	getFormDataTables = async (Form_Widgets) => {
		const Data_Tables_Promise_List = Form_Widgets.filter((obj) => obj.Widget_Type_ID === WidgetTypes.DataTable).map((obj) => {
			return getDT(obj.Widget_ID);
		});

		const Data_Tables_List = await (await Promise.all(Data_Tables_Promise_List))
			.map((obj) => obj.data)
			.map((obj) => ({ ...obj, Parameters: JSON.parse(obj.Parameters), Data_Table_Name: JSON.parse(obj.DT)[0].Display_Name }));

		this.setState({ Data_Tables_List });
	};

	handleChange = ({ target }) => {
		let name = target.name;
		let value = target.value;

		if (name.includes('ID')) {
			name = name.split(':').pop();
			value = parseInt(value);
		}
		this.setState({ [name]: value });

		if (name === 'ResultSource_ID') {
			this.clearStatus();
		} else if (name === 'DataSource_ID') {
			this.getOptions(value);
			this.setState({ can_save: false });
		}
	};

	getConn(DataSource_ID = this.state.DataSource_ID) {
		const source = this.DataSources.find((source) => {
			return source.DataSource_ID === DataSource_ID;
		});
		return source.Connection_String;
	}

	handleSelectDataTable = ({ target }) => {
		//console.log("handleSelectDataTable target: ", target.value)
		if (target.value !== 0) {
			const Data_Table_Selected = JSON.parse(target.value);
			//this.setState({Data_Table_Selected})
			const { Parameters, DT: DTStringified } = Data_Table_Selected;

			const { DT_ID } = JSON.parse(DTStringified)[0];
			//console.log('Parameters', Parameters)
			const Data_Table_Selected_Parameters = Parameters.map((obj) => ({ ...obj, Filter_Type: '', List_Selected: null }));

			this.setState({ Data_Table_Selected, Data_Table_Selected_Parameters, DT_ID });
			//console.log("handleSelectDataTable: ", Data_Table_Selected, Data_Table_Selected_Parameters, DT_ID)
		}
	};

	handleSelectParameterFilterType = ({ target }) => {
		
		const { Data_Table_Selected_Parameters: Old_Data_Table_Selected_Parameters, Filter_Type_List } = this.state;
		const Data_Table_Selected_Parameters = Old_Data_Table_Selected_Parameters.map((obj) => {
			if (obj.Parameter_ID === parseInt(target.name)) {
				
				const Filter_Type_Obj = Filter_Type_List.filter((obj) => obj.Filter_Type === JSON.parse(target.value).Filter_Type)[0];
				return { ...obj, Filter_Type:Filter_Type_Obj,Type:Filter_Type_Obj.Filter_Type};
			}
			return {...obj};
		});

		this.setState({ Data_Table_Selected_Parameters });
	};

	handleSelect = ({target}) =>{
		
		const { Data_Table_Selected_Parameters: Old_Data_Table_Selected_Parameters, Filter_Type_List } = this.state;
		const Data_Table_Selected_Parameters = Old_Data_Table_Selected_Parameters.map((obj) => {
			if (obj.Parameter_ID === parseInt(target.id)) {
				
				const Filter_Type_Obj = Filter_Type_List.filter((obj) => obj.Filter_Type === target.value)[0];
				return { ...obj, Filter_Type:Filter_Type_Obj,Type:Filter_Type_Obj.Filter_Type};
			}
			return {...obj};
		});

		this.setState({ Data_Table_Selected_Parameters });
	}

	handleSelectList = (Parameter_ID,{ target }) => {

		const List_Selected = JSON.parse(target.value);
		const { Data_Table_Selected_Parameters: Old_Data_Table_Selected_Parameters, Filter_Type_List } = this.state;
		const Data_Table_Selected_Parameters = Old_Data_Table_Selected_Parameters.map((obj) => {
			if (obj.Parameter_ID === parseInt(Parameter_ID)) {

				return { ...obj, List_Selected};
			}
			return obj;
		});

		this.setState({ Data_Table_Selected_Parameters });
	};

	handleSPVChange = async (e, value) => {
		this.setState({ ResultSource_Content: value });

		if (this.state.ResultSource_ID === ResultSource.SP) {
			const { data } = await findParameters(value, this.getConn());
			if (typeof data === 'object') {
				const Parameters = data.map((par) => {
					par.Parameter_ID = 0;
					par.Default_Value = '';
					return par;
				});
				this.setState({ Parameters });
			}
		}
	};

	findColumns = async () => {
		const { data } = await toFindColumns(this.state.ResultSource_ID, this.state.ResultSource_Content, this.getConn(), this.state.Parameters, true);

		if (typeof data === 'string') {
			toaster('error', data);
		} else {
			this.setState({ can_save: true });
			const Columns = data.map((col) => {
				return {
					Column_ID: 0,
					Column_Name: col,
					Column_Display_Name: col ? col : '(no column name)',
					isPrimary: false,
					Visible: false,
				};
			});
			this.setState({ Columns });
		}
	};

	handleSave = async () => {
		const { DT_ID, Data_Table_Selected_Parameters:Old_Date_Table_Selected_Parameters,Form_ID,Widget_ID } = this.state;
		const Data_Table_Selected_Parameters = Old_Date_Table_Selected_Parameters.map(obj =>{
			return {...obj,List_ID:obj.List_Selected?.List_ID ??null}
		});

		const { data } = await saveDTParameters(Form_ID,Widget_ID,DT_ID, Data_Table_Selected_Parameters);
		if (data.includes('Error')) {
			toaster('error', data);
			logActivity('/widget', 'WIDGET_FILTER_SAVE_FAILED');
		} else {
			toaster('success', 'Filter widget saved.');
            logActivity('/widget', 'WIDGET_FILTER_SAVE_SUCCESS');
			const DT_ID = data.split(':').pop();
			this.setState({ DT_ID });
			this.loadDT();
		}
	};

	handleRemove = () => {
		this.props.onRemove(this.state.Widget_ID);
	};

	handldParChange = (text, index) => {
		const Parameters = [...this.state.Parameters];
		Parameters[index]['Default_Value'] = text;
		this.setState({ Parameters });
	};

	handleCheck = () => {
		this.setState({ WithinRow: !this.state.WithinRow });
	};

	handleColumn = ({ target }) => {
		let column = target.value;

		let Columns = [...this.state.Columns];
		Columns = Columns.map((col) => {
			col.Visible = col.Column_Name === column ? true : false;
			col.isPrimary = col.Column_Name === column ? true : false;
			return col;
		});
		this.setState({ selected_column: column });
		this.setState({ Columns: Columns });
	};

	render() {
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}

		const {
			DataSource_ID,
			Action_ID,
			Action_Form_ID,
			ResultSource_ID,
			Display_Name,
			ResultSource_Content,
			Widget_ID,
			open_options,
			Parameters,
			WithinRow,
			Columns,
			Data_Tables_List,
			Data_Table_Selected,
			Filter_Type_List,
			Data_Table_Selected_Parameters,
			Project_Lists
		} = this.state;
	
		return (
			<React.Fragment>
				<div className='form-group'>
					<label htmlFor={'data_table_select' + Widget_ID}>Select Data Table</label>
					<select
						id={'data_table_select' + Widget_ID}
						name={Widget_ID + ':data_table_select'}
						value={JSON.stringify(Data_Table_Selected)}
						className='form-control'
						onChange={(e)=>this.handleSelectDataTable(e)}
					>
						<option value='0'>Select</option>
						{Data_Tables_List.map((obj) => {
							return (
								<option key={obj.Data_Table_Name} value={JSON.stringify(obj)}>
									{obj.Data_Table_Name}
								</option>
							);
						})}
					</select>
				</div>
				{Data_Table_Selected_Parameters.length > 0 &&  (
					<div className='form-group'>
						<label htmlFor={'data_table_select' + Widget_ID}>Select Data Table Filter Types</label>
						<div className='form-group '>
							{Data_Table_Selected_Parameters &&
								Data_Table_Selected_Parameters.map((obj) => {
									return (
										<div key={obj.Parameter_ID} className='form-row'>
											<div>
												<p>Parameter:</p>
												<p>{obj.Name.substring(1)}</p>
											</div>

											<select id={obj.Parameter_ID} name={obj.Parameter_ID} value={JSON.stringify(obj.Filter_Type)} className='form-control' onChange={this.handleSelectParameterFilterType}>
												<option value='0'>Select</option>
												{Filter_Type_List.map((obj) => (
													<option key={obj.id} value={JSON.stringify(obj)}>
														{obj.Filter_Type}
													</option>
												))}
												
											</select>
											
											<br />
											
											{Filter_Type_List.map((filterType) => (
													<div className="form-check form-check-inline" key={filterType.id}>
													<input
													  type="radio"
													  className="form-check-input"
													//   id={obj.Parameter_ID}
													id={ obj.Parameter_ID}
													  name= {filterType.Parameter_ID} 
													  value={filterType.Filter_Type}
													  checked={filterType.id === obj.Filter_Type.id}
													  onChange={this.handleSelect}
													/>
													<label
													  htmlFor={filterType.Filter_Type}
													  className="form-check-label"
													>
													 {filterType.Filter_Type}
													</label>
												  </div>
												))}
											{
												obj.Filter_Type.id===3 &&
												<>
												<br/>
												<select id={obj.Parameter_ID} name={obj.Parameter_ID} value={JSON.stringify(obj.List_Selected)} 
												className='form-control' onChange={this.handleSelectList.bind(null,obj.Parameter_ID)}>
												<option value='0'>Select</option>
												{Project_Lists.map((obj) => (
													<option key={obj.id} value={JSON.stringify(obj)}>
														{obj.List_Name}
													</option>
												))}
												
											</select>
											
											</>
											}
										</div>
									);
								})}
						</div>
					</div>
				)}

				{/* <div className='form-group'>
					<div className='form-check'>
						<input type='checkbox' className='form-check-input' checked={WithinRow} onChange={this.handleCheck} />
						<label htmlFor='' className='form-check-label'>
							Include in row widget
						</label>
					</div>
				</div> */}

				{/* <div className='form-group'>
					<label htmlFor=''>Info Source</label>
					<div className='form-check'>
						{this.ResultSources.map((source) => {
							return (
								<div className='form-check form-check-inline' key={Widget_ID + source.ResultSource_Type_Name}>
									<input
										type='radio'
										className='form-check-input'
										name={Widget_ID + ':ResultSource_ID'}
										value={source.ResultSource_ID}
										checked={source.ResultSource_ID === ResultSource_ID}
										onChange={this.handleChange}
									/>
									<label htmlFor={Widget_ID + source.ResultSource_Type_Name} className='form-check-label'>
										{source.ResultSource_Type_Name}
									</label>
								</div>
							);
						})}
					</div>
				</div> */}

				{/* {ResultSource_ID === 0 && (
					<div className='form-group'>
						<label htmlFor=''>Content</label>
						<input type='text' className='form-control' value={ResultSource_Content} name='ResultSource_Content' disabled={ResultSource_ID !== 0} onChange={this.handleChange} />
					</div>
				)} */}

				{/* <div className='form-row' key={Widget_ID + 'clickEvent'}>
					<div className='form-group col-md-4'>
						<label htmlFor={'row_action' + Widget_ID}>Click Event Action</label>
						<select id={'row_action' + Widget_ID} name={Widget_ID + ':Action_ID'} value={Action_ID} className='form-control' onChange={this.handleChange}>
							<option value='0'>Select</option>
							{this.RowActions.map((action) => {
								return (
									<option key={action.Action_ID} value={action.Action_ID}>
										{action.Action_Name}
									</option>
								);
							})}
						</select>
					</div>
					<div className='form-group col-md-8'>
						<label htmlFor={'action_form' + Widget_ID}>Form</label>
						<select id={'action_form' + Widget_ID} className='form-control' name={Widget_ID + 'Action_Form_ID'} value={Action_Form_ID} onChange={this.handleChange}>
							<option value='-1'>Select</option>
							<option value='0'>On user selection</option>
							{this.Forms.map((form) => {
								return (
									<option key={form.Form_ID} value={form.Form_ID}>
										{form.Form_Name}
									</option>
								);
							})}
						</select>
					</div>
				</div> */}

				{/* {ResultSource_ID > 0 && (
					<React.Fragment>
						<div className='form-group'>
							<label htmlFor={'DataSource' + Widget_ID}>Data Source</label>
							<select id={'DataSource' + Widget_ID} className='form-control' value={DataSource_ID} name='DataSource_ID' onChange={this.handleChange}>
								<option value='0' key={Widget_ID + 'DSDefault'}>
									Select
								</option>
								{this.DataSources.map((source) => (
									<option key={Widget_ID + 'DataSource' + source.DataSource_ID} value={source.DataSource_ID}>
										{source.Description}
									</option>
								))}
							</select>
						</div>

						{DataSource_ID !== 0 && (
							<React.Fragment>
								<div className='form-group'>
									{ResultSource_ID === ResultSource.Query && (
										<div>
											<TextField
												id={Widget_ID + 'resultSourceContent'}
												label='Enter Query'
												variant='outlined'
												fullWidth
												margin='dense'
												name='ResultSource_Content'
												value={ResultSource_Content}
												onChange={this.handleChange}
											/>
										</div>
									)}

									{(ResultSource_ID === ResultSource.SP || ResultSource_ID === ResultSource.View) && (
										<div>
											<Autocomplete
												id={Widget_ID + 'resultSourceContent'}
												options={open_options ? (ResultSource_ID === ResultSource.SP ? this.StoredProcedures : this.Views) : []}
												getOptionLabel={(option) => option}
												fullWidth
												size='small'
												value={ResultSource_Content}
												name='ResultSource_Content'
												onChange={this.handleSPVChange}
												inputValue={open_options}
												onInputChange={(e, val) => {
													this.setState({ open_options: val });
												}}
												renderInput={(params) => <TextField {...params} label={ResultSource_ID === ResultSource.SP ? 'Stored Procedure Name' : 'View Name'} />}
											/>
										</div>
									)}

									{ResultSource_ID === ResultSource.SP &&
										Parameters.length > 0 &&
										Parameters.map((par, idx) => (
											<TextField
												id={Widget_ID + '.' + par.Name}
												label={par.Name + '(' + par.Type + ')'}
												placeholder='Default Value'
												fullWidth
												value={par.Default_Value}
												key={Widget_ID + 'parameter' + par.Name}
												onChange={(e) => this.handldParChange(e.target.value, idx)}
											/>
										))}
								</div>

								<div className='form-group'>
									<label htmlFor=''>
										Column to display{' '}
										<OverlayTrigger placement='top' overlay={<Tooltip>find columns</Tooltip>}>
											<span className='badge badge-success pointer' onClick={this.findColumns}>
												<Icon.Search size={16} />
											</span>
										</OverlayTrigger>
									</label>

									<select name={Widget_ID + 'cols'} className='form-control' onChange={this.handleColumn} name={Widget_ID + 'Column'} value={this.state.selected_column}>
										<option value='0' key={Widget_ID + 'col' + 'Default'}>
											- Select -
										</option>
										{Columns.map((column) => (
											<option
												value={column.Column_Name}
												key={Widget_ID + 'col' + column.Column_Name}
												// selected={column.Visible}
											>
												{column.Column_Display_Name}
											</option>
										))}
									</select>
								</div>
							</React.Fragment>
						)}
					</React.Fragment>
				)} */}

				<hr className='my-4' />
				<div className='d-flex justify-content-end'>
					<button className='btn btn-outline-primary mr-2' onClick={this.handleSave} disabled={!this.state.can_save}>
						Save
					</button>
					<button className='btn btn-outline-danger' onClick={this.handleRemove}>
						Delete
					</button>
				</div>
				<ToastContainer/>
			</React.Fragment>
		);
	}
}

export default WFilter;
